export default __webpack_public_path__ + "static/media/82.eeb87600.png";